import { useState, useEffect } from "react";
import { SERVER_URL } from "../../constants";
import { Grid, Paper, Button, Typography } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UpdateVendor = (props) => {
  return (
    <div>
      <h1>Update Vendor</h1>
    </div>
  );
};

export default UpdateVendor;
